import React, { useState } from 'react';
import { useAppDispatch } from '../../config/hooks';
import { updateClientApi } from '../../slices/salesSlice';
import { toast } from 'sonner';

const AdditionalDetailForm = ({initialData,togglePopupHandler}) => {
  const [formData, setFormData] = useState({
    companySize: initialData?.companySize || '',
    noOfEmployees: initialData?.noOfEmployees ||'',
    turnover:initialData?.turnover || ''
  });

  const dispatch=useAppDispatch()

  const companySizes = [
    { id: 1, label: 'Small' },
    { id: 2, label: 'Medium' },
    { id: 3, label: 'Large' }
  ];

  const employeeCounts = [
    { id: 1, label: '1-10' },
    { id: 2, label: '11-50' },
    { id: 3, label: '51-200' },
    { id: 4, label: '201-500' },
    { id: 5, label: '500+' }
  ];

  const turnovers = [
    { id: 1, label: '< $1M' },
    { id: 2, label: '$1M - $10M' },
    { id: 3, label: '$10M - $50M' },
    { id: 4, label: '$50M+' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Saved IDs:', formData);

    dispatch(updateClientApi({ id: initialData?.id, ...formData }));
    togglePopupHandler();
    toast.success("Updated Successfully");
    // Add your API integration here
  };

  return (
    <div className="  flex items-center justify-center  ">
      <form
        onSubmit={handleSubmit}
        className=" bg-white rounded-lg  min-w-[40vw]"
      >
        <h2 className="text-2xl font-semibold mb-6 text-center text-gray-700">
          Additional Details
        </h2>

        <div className="mb-4">
          <label className="block text-gray-600 mb-2">Company Size</label>
          <select
            name="companySize"
            value={formData.companySize}
            onChange={handleChange}
            
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="">Select Company Size</option>
            {companySizes.map(size => (
              <option key={size.id} value={size.id}>{size.label}</option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-gray-600 mb-2">Number of Employees</label>
          <select
            name="noOfEmployees"
            value={formData.noOfEmployees}
            onChange={handleChange}
           
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="">Select Employee Count</option>
            {employeeCounts.map(emp => (
              <option key={emp.id} value={emp.id}>{emp.label}</option>
            ))}
          </select>
        </div>

        <div className="mb-6">
          <label className="block text-gray-600 mb-2">Turnover</label>
          <select
            name="turnover"
            value={formData.turnover}
            onChange={handleChange}
           
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="">Select Turnover</option>
            {turnovers.map(turn => (
              <option key={turn.id} value={turn.id}>{turn.label}</option>
            ))}
          </select>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-md transition duration-200"
        >
          Save
        </button>
      </form>
    </div>
  );
};

export default AdditionalDetailForm;
